import { useEffect, useRef, useState } from 'preact/hooks';
import WaveSurfer from 'wavesurfer.js';
import playArrow from '/src/assets/playArrow.svg';
import pause from '/src/assets/pause.svg';
import { CHATBOT_CHAT_MSJ_FROM_CLIENT } from '../utils/constants.js';
import clsx from 'clsx';

const base64ToBlobChatbot = (base64, contentType = 'audio/mpeg') => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}

function formatTimeChatbot(seconds) {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
}

export default function AudioPlayerChatbot({audioData, from}) {
  const waveformRef = useRef(null);
  const wavesurferRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [audioURL, setAudioURL] = useState(null);

  useEffect(() => {
    if (waveformRef.current && audioData) {
      if (wavesurferRef.current) {
        wavesurferRef.current.destroy();
      }

      const blob = base64ToBlobChatbot(audioData, 'audio/mpeg');
      const url = URL.createObjectURL(blob);
      setAudioURL(url);
      const waveColor = from !== CHATBOT_CHAT_MSJ_FROM_CLIENT ? '#000C3A' : '#D9DCFF';
      const progressColor = from !== CHATBOT_CHAT_MSJ_FROM_CLIENT ? '#575fdd' : '#000C3A';
      const wavesurfer = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: waveColor,
        progressColor: progressColor,
        height: 'auto',
        barWidth: 2,
        barGap: 1,
        barRadius: 2,
        cursorWidth: 1,
        backend: 'MediaElement',
        normalize: true,
      });

      wavesurfer.load(url);
      wavesurferRef.current = wavesurfer;

      wavesurfer.on('ready', () => {
        setDuration(wavesurfer.getDuration());
      });

      wavesurfer.on('play', () => {
        setIsPlaying(true);
      });

      wavesurfer.on('pause', () => {
        setIsPlaying(false);
      });

      wavesurfer.on('finish', () => {
        setIsPlaying(false);
        wavesurfer.seekTo(0);
      });
    }

    return () => {
      if (wavesurferRef.current) {
        wavesurferRef.current.destroy();
        wavesurferRef.current = null;
      }
      if (audioURL) {
        URL.revokeObjectURL(audioURL);
        setAudioURL(null);
      }
    };
  }, [audioData, from]);

  const handlePlayPause = () => {
    if (wavesurferRef.current) {
      wavesurferRef.current.playPause();
    }
  };
  return (
    <div className="bot-utn-audio-player">
      <div className="bot-utn-container-options-audio-player">
        <button onClick={handlePlayPause}>
          {
            isPlaying ?
              <img
                className={clsx("bot-utn-play-and-pause", {'bot-utn-colors-client': from !== CHATBOT_CHAT_MSJ_FROM_CLIENT})}
                src={pause} alt='Pausar audio'/> :
              <img
                className={clsx("bot-utn-play-and-pause", {'bot-utn-colors-client': from !== CHATBOT_CHAT_MSJ_FROM_CLIENT})}
                src={playArrow} alt='Reproducir audio'/>
          }
        </button>
      </div>
      <div className={clsx("bot-utn-waveform", {'bot-utn-colors-client': from !== CHATBOT_CHAT_MSJ_FROM_CLIENT})}
           ref={waveformRef}></div>
    </div>
  );
}
